import Checkbox from '../../../common/components/Checkbox.js'
import {useSelector} from '../../../store.js'
import {
  isLabelPropertyEnabledSelector,
  isLabelPropertyOverrideSelector,
  setOverrideProperty,
} from '../../../data/labelInfos/index.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'

/**
 * Component to determine if properties in presets should override or add to label config
 *
 * Put it in all label config properties that are array like shipper_ids and package_types
 *
 * @param {Object} props
 * @param {Object} props.propertySpecs
 * @param {String} [props.label] A label to describe what is getting overridden
 * @param {Function} [props.labelPropertyCheckedSelector] A function to determine if the preset property is enabled
 * @param {String} [props.helpLink] A link to help
 * @param {String} [props.helpTitle] Help text
 * @returns {React.ReactNode}
 */
export default function OverrideLabelProperty({
  propertySpecs,
  label,
  labelPropertyCheckedSelector,
  helpLink,
  helpTitle,
}) {
  const {labelInfoID, isLabelEnableMode, shipperType} = useLabelConfigContext()
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )
  const checked = useSelector((state) =>
    isLabelPropertyOverrideSelector(state, {
      labelProperty,
      labelInfoID,
    }),
  )
  const labelPropertyEnabled = useSelector(
    labelPropertyCheckedSelector ||
      ((state) =>
        isLabelPropertyEnabledSelector(state, {
          labelProperty,
          labelInfoID,
        })),
  )

  if (!labelProperty || !isLabelEnableMode) {
    return null
  }

  return (
    <div className="margin-top-10 w-100">
      <Checkbox
        mode="fancy"
        label={label}
        id={`override__${labelInfoID}__${labelProperty}`}
        checked={checked}
        onChange={(checked) =>
          setOverrideProperty(labelInfoID, shipperType, propertySpecs, checked)
        }
        disabled={!labelPropertyEnabled}
        helpLink={helpLink}
        helpTitle={helpTitle}
      />
    </div>
  )
}
